<div class="d-flex justify-content-between align-items-center p-2 border-bottom">
    <h5 class="m-0">E-Invoice Documents</h5>
    <div class="d-flex gap-2">
        <button class="btn btn-light btn-sm" (click)="addEInvoiceDoc()"><i class="fas fa-plus"></i></button>
    </div>
</div>
<div class="p-3">
    <div class="d-flex flex-wrap gap-2 align-items-center">
        <div>Filter:</div>
        <mat-chip-listbox class="gap-2">
            <mat-chip-option class="my-0">Last 3 months</mat-chip-option>
            <mat-chip-option class="my-0">Last 6 months</mat-chip-option>
            <mat-chip-option class="my-0">Last 12 months</mat-chip-option>
        </mat-chip-listbox>
    </div>
    <table mat-table [dataSource]="table.dataSource()" matSort (matSortChange)="table.sortState.set($event)">
        <ng-container matColumnDef="Expand">
            <th mat-header-cell *matHeaderCellDef style="width: 10px;"></th>
            <td mat-cell *matCellDef="let d">
            @if (d.EInvoiceNumber === undefined) {
                <span class="pointer" (click)="toggleCollapse(d)">
                @if (expanded().includes(d.Id)) {
                    <i class="fas fa-chevron-down text-secondary"></i>
                } @else {
                    <i class="fas fa-chevron-right text-secondary"></i>
                }
                </span>
            }
            </td>
        </ng-container>
        <ng-container matColumnDef="Actions">
            <th mat-header-cell *matHeaderCellDef style="width: 10px;"></th>
            <td mat-cell *matCellDef="let d">
            @if ((d.EInvoiceNumber === undefined || !isCombined(d)) && d.SubmittedOn === undefined) {
                <i class="fas fa-pencil-alt text-secondary pointer" (click)="openEInvoiceDoc(d.LicenseId, d.IssuanceDate)"></i>
            }
            </td>
        </ng-container>
    @for (c of table.config(); track c.columnDef) {
        <ng-container [matColumnDef]="c.columnDef">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ c.header }}</th>
            <td mat-cell *matCellDef="let d">
            @if (c.type === "boolean") {
                <mat-checkbox [checked]="d[c.property]" disabled="true"></mat-checkbox>
            } @else if (c.onClick) {
                <div (click)="c.onClick(d)" class="pointer">{{ table.formatValue(d, c) }}</div>
            } @else {
                {{ table.formatValue(d, c) }}
            }
            </td>
        </ng-container>
    }
        <tr mat-header-row *matHeaderRowDef="displayedColumns(); sticky: true"></tr>
        <tr mat-row *matRowDef="let d; columns: displayedColumns()" [class.d-none]="!expanded().includes(d.Id)"></tr>
        <tr *matNoDataRow>
            <td class="no-data-cell p-3 fw-semibold" [attr.colspan]="table.columnDefs().length">No record found.</td>
        </tr>
        <tr mat-row *matRowDef="let group; columns: displayedColumns(); when: isGrouped" class="position-sticky" style="top: 56px; z-index: 3"></tr>
    </table>
</div>